const WeatherMonitoringAlertCards = ({ monitoring }) => {
  if (!monitoring) {
    return null;
  }

  const counts = monitoring.activeAlerts || {};
  const cards = [
    {
      label: "Critical alerts",
      value: counts.critical ?? 0,
      tone: counts.critical > 0 ? "red" : null,
    },
    {
      label: "Warning alerts",
      value: counts.warning ?? 0,
      tone: counts.warning > 0 ? "amber" : null,
    },
    {
      label: "Info alerts",
      value: counts.info ?? 0,
    },
    {
      label: "Fallback active",
      value: monitoring.fallback?.active ? "Yes" : "No",
      tone: monitoring.fallback?.active ? "amber" : null,
    },
    {
      label: "Both radar down",
      value: monitoring.bothRadarSourcesDown ? "Yes" : "No",
      tone: monitoring.bothRadarSourcesDown ? "red" : null,
    },
    {
      label: "Cache warnings",
      value: monitoring.cache?.warningCount ?? 0,
      tone: (monitoring.cache?.warningCount ?? 0) > 0 ? "amber" : null,
    },
  ];

  return (
    <section className="admin-dashboard__kpis">
      {cards.map((card) => (
        <div className="admin-dash__kpi-card" key={card.label}>
          <span className="admin-dash__kpi-label">{card.label}</span>
          <span
            className={`admin-dash__kpi-value${
              card.tone ? ` admin-dash__kpi-value--${card.tone}` : ""
            }`}
          >
            {card.value}
          </span>
        </div>
      ))}
    </section>
  );
};

export default WeatherMonitoringAlertCards;
